module.exports = __webpack_public_path__ + "static/media/vip-message-background.e6cee34d.png";